import React, { Component, Fragment } from 'react';
import TutorialEndContainer from '../../containers/TutorialEndContainer';

class Intro extends Component {
    render() {
        return (
            <TutorialEndContainer {...this.props} />
        );
    }
}
export default Intro;


// WEBPACK FOOTER //
// /src/screens/TutorialEnd/index.js